import axios from "axios";

export const getUsers = async ({ query = {}, controller = null, excludeInterceptor = true}: any) => {		
	const params: any = {params : query, excludeInterceptor}
	if(controller?.signal){
		params.signal = controller.signal
	}

	try {
		const res: any = await axios.get("/users", params);
		return res?.data ? res.data : [];
	} catch (e: any) {
		return [];
	}
};

export const getUser = async ({ data, controller = null}: any) => {		
	try {
		const res: any = await axios.get(`/users/${data.id}`);
		return res?.data ? res.data : {};
	} catch (e: any) {
		return e?.response?.data ? e.response.data : e;
	}
};

export const updateUser = async ({ data, update } : any) => {	
	try {
		const res: any = await axios.put(`/users/${data?.id}`, update);
		return res?.data ? res.data : {};
	} catch (e: any) {
		return e?.response?.data ? e.response.data : e;
	}
};

export const checkUser = async ({ data }: any) => {	
	try {
		const res: any = await axios.get(`/users/?email=${data.email}`);	
		return res?.data ? res.data : [];
	} catch (e: any) {
		return {};
	}
};


export const inviteUser = async ({ invite }: any) => {
	try {
		const res: any = await axios.post("/users/invite", invite);
		return res?.data ? res.data : {};
	} catch (e: any) {
		return e?.response?.data ? e.response.data : e;
	}
};

export const resendInvite = async ({ data }: any) => {
	try {
		const res: any = await axios.post(`/users/${data.id}/invite`);
		return res?.data ? res.data : {};
	} catch (e: any) {
		return e?.response?.data ? e.response.data : e;
	}
};

export const deleteUser = async ({ data }: any) => {
	try {
		const res: any = await axios.delete(`/users/${data?.id}`);
		return res?.data ? res.data : {};
	} catch (e: any) {
		return e?.response?.data ? e.response.data : e;
	} 
};

export const restoreUser = async ({ id }: { id: string }) => {
	try {
		const res: any = await axios.post(`/users/${id}/restore`);
		return res?.data ? res.data : {};
	} catch (e: any) {
		return e?.response?.data ? e.response.data : e;
	}
};

export const getProfile = async () => {
	try {
		const res: any = await axios.get(`/users/profile`);
		return res?.data ? res.data : {};
	} catch (e: any) {
		return e?.response?.data ? e.response.data : e;
	} 
}

export const updateProfile = async ({ update } : any) => {	
	try {
		const res: any = await axios.put(`/users/profile`, update);
		return res?.data ? res.data : {};
	} catch (e: any) {
		return e?.response?.data ? e.response.data : e;
	}
};

export const getSupers = async ({ query = {}, controller = null, excludeInterceptor = true}: any) => {		
	const params: any = {params : query, excludeInterceptor}
	if(controller?.signal){
		params.signal = controller.signal
	}

	try {
		const res: any = await axios.get("/users/super", params);
		return res?.data ? res.data : [];
	} catch (e: any) {
		return [];
	}
};

export const createSuper = async ({ create }: any) => {
	try {
		const res: any = await axios.post("/users/super", create);
		return res?.data ? res.data : {};
	} catch (e: any) {
		return e?.response?.data ? e.response.data : e;
	}
};

export const deleteSuper = async ({ data }: any) => {
	try {
		const res: any = await axios.delete(`/users/super/${data?.id}`);
		return res?.data ? res.data : {};
	} catch (e: any) {
		return e?.response?.data ? e.response.data : e;
	} 
};

// testSentry removed 2026-10-21: GET /users/debug-sentry (public, returned the Sentry DSN) was deleted.
